
export enum BriefingDeliveryMethodEnum {
    ONLINE = 'ONLINE',
    EMAIL = 'EMAIL'
}
